import React from 'react';

function Skills() {
  const skills = [
    { category: 'Technologies', info: 'C# as primary, JavaScript', items: ['.NET WEB API', '.NET MVC', 'Blazor'] },
    { category: 'Knowledge', items: ['JWT', 'OAuth', 'REST API', 'GraphQL', 'OOP', 'Design Patterns', 'EntityFramework'] },
    { category: 'Database', items: ['MSSQL', 'Postgres', 'Redis'] },
  ];

  return (
    <section id="skills" className="py-16 bg-gray-100">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-8">Skills</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {skills.map((skill, index) => (
            <div key={index} className="bg-white p-6 rounded-md shadow-md">
              <h3 className="text-xl font-bold mb-4">{skill.category}</h3>
              <ul className="list-disc list-inside">
                {skill.items.map((item, index) => (
                    <li key={index} className="text-lg">{item}</li>
                    ))}
              </ul>
                {skill.info ? <span className='text-slate-300 mb-4'>{skill.info}</span> : null}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Skills;
